import { render, staticRenderFns } from "./LeaderboardCompanies.vue?vue&type=template&id=424f7f62"
import script from "./LeaderboardCompanies.vue?vue&type=script&lang=js"
export * from "./LeaderboardCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports